






















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';
import isEqual from 'lodash/isEqual';

import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import { updateRegistration } from '@/utils/updateRegistration';
import eventBus from '@/utils/eventBus';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import BusinessService from '@/api/BusinessService';
import { isRemoteLoading } from '@/utils/remote-loading';
import segmentIo from '@/utils/segment.io';

type FormData = {
  firstName: string;
  lastName: string;
  mail: string;
};

function defaultFormData(): FormData {
  return {
    firstName: '',
    lastName: '',
    mail: ''
  };
}

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    Page,
    FilledButton,
    Input,
    Typography
  }
})
export default class Account extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  managerService = new BusinessService();
  formData: FormData = defaultFormData();
  formDataClone: FormData = defaultFormData();
  loading = false;

  get isRemoteLoading() {
    return isRemoteLoading();
  }

  get isEqualForm() {
    return isEqual(this.formData, this.formDataClone);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get manager() {
    return this.businessInfo.manager;
  }

  mounted() {
    setFocusOnFirstInput();
    this.fillInitialFormData();
  }

  async handleUpdateBusiness() {
    const res = await this.managerService.getBusinessInfo();

    if (res.status !== 200) return;

    eventBus.$emit('setBusinessInfo', res.data);

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...res.data,
      manager: res.data.loggedInManager,
      loggedInManager: res.data.loggedInManager
    });
  }

  fillInitialFormData() {
    if (!this.manager) return;

    const manager = this.manager || {};
    const fullname = manager.fullname || '';
    const mail = manager.mail || '';

    const nameParts = fullname ? fullname.trim().split(' ') : [];
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    const newFormData = {
      firstName,
      lastName,
      mail
    };

    this.formData = newFormData;
    this.setFormDataClone(newFormData);
  }

  setFormDataClone(formData: FormData) {
    this.formDataClone = Object.assign({}, formData);
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');

      return;
    }

    try {
      this.loading = true;

      const payload = {
        fullname: `${this.formData.firstName} ${this.formData.lastName}`.trim(),
        mail: this.formData.mail
      };

      const { status } = await this.managerService.updateManager(payload);

      if (status !== 200) return;

      await Promise.allSettled([
        this.handleUpdateBusiness(),
        updateRegistration('complete-your-profile')
      ]);

      this.$notification('Profile updated successfully');
      segmentIo.track('Profile updated');
      this.setFormDataClone(this.formData);
    } finally {
      this.loading = false;
    }
  }
}
